import { useTranslation } from 'react-i18next';
import { IFormInstance, useWatchForm } from '@/components';
import { useGetRequiredRule, useLengthValidationRule } from '@/hooks';
import { DeliverySettingsFormFields } from '../helpers';
import { Rule } from 'antd/es/form';

export const useDeliverySettingsFormRules = (form: IFormInstance) => {
  const { t } = useTranslation(['validations']);
  const requiredRule = useGetRequiredRule({ t });
  const popupTitleLengthRule = useLengthValidationRule({ t, max: 100 });
  const popupDescriptionLengthRule = useLengthValidationRule({ t, max: 250 });

  const isUPSEnabled = useWatchForm(
    [DeliverySettingsFormFields.UPS_DELIVERY, DeliverySettingsFormFields.IS_ENABLED],
    form,
  );

  const getUpsRules = (rules: Rule[]) => {
    return isUPSEnabled ? rules : [];
  };

  const isFreeDeliveryEnabled = useWatchForm(
    [DeliverySettingsFormFields.FREE_DELIVERY, DeliverySettingsFormFields.IS_ENABLED],
    form,
  );

  const getFreeDeliveryRules = (rules: Rule[]) => {
    return isFreeDeliveryEnabled ? rules : [];
  };

  return {
    [DeliverySettingsFormFields.FREE_DELIVERY]: {
      [DeliverySettingsFormFields.IS_ENABLED]: [requiredRule],
      [DeliverySettingsFormFields.MIN_ORDER_AMOUNT]: getFreeDeliveryRules([requiredRule]),
      [DeliverySettingsFormFields.POPUP_TITLE]: [...getFreeDeliveryRules([requiredRule]), popupTitleLengthRule],

      [DeliverySettingsFormFields.POPUP_DESCRIPTION]: [
        ...getFreeDeliveryRules([requiredRule]),
        popupDescriptionLengthRule,
      ],
    },
    [DeliverySettingsFormFields.UPS_DELIVERY]: {
      [DeliverySettingsFormFields.IS_ENABLED]: [requiredRule],
      [DeliverySettingsFormFields.PRICE]: getUpsRules([requiredRule]),
    },
  };
};
